var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-stats"},[_c('div',{staticClass:"stats-header"},[_vm._t("header")],2),_c('div',[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }